module.exports = __webpack_public_path__ + "src/assets/games/30/42.jpg";